import { Box, Dialog, styled } from '@mui/material';
import React, { useState } from 'react';

const LogoContainer = styled(Box)<{ size?: number; borderRadius?: number }>(
  ({ theme, size = 80, borderRadius = 8 }) => ({
    width: size,
    height: size,
    borderRadius: borderRadius,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    boxShadow: theme.shadows[1],
    cursor: 'pointer',
  })
);

const LogoImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});

const ClientLogo = ({ imageUrl, alt = 'Company Logo', size = 80, borderRadius = 8 }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => imageUrl && setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <LogoContainer size={size} borderRadius={borderRadius}>
        <LogoImage src={imageUrl} alt={alt} onClick={handleOpen} />
      </LogoContainer>
      <Dialog open={open} onClose={handleClose} sx={{ borderRadius: 10 }}>
        <img src={imageUrl} alt={alt} style={{ width: '100%' }} />
      </Dialog>
    </>
  );
};

export default ClientLogo;
